import { QuestionType } from '@act/shared/types';
import ArrowDropDownCircleOutlinedIcon from '@mui/icons-material/ArrowDropDownCircleOutlined';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import RadioButtonCheckedOutlinedIcon from '@mui/icons-material/RadioButtonCheckedOutlined';
import TextFieldsOutlinedIcon from '@mui/icons-material/TextFieldsOutlined';

interface QuestionTypeIconProps {
  type: QuestionType;
}

const QuestionTypeIcon = ({ type }: QuestionTypeIconProps) => {
  switch (type) {
    case 'checkbox':
      return <CheckBoxOutlinedIcon />;
    case 'date':
      return <EventAvailableOutlinedIcon />;
    case 'radio':
      return <RadioButtonCheckedOutlinedIcon />;
    case 'select':
      return <ArrowDropDownCircleOutlinedIcon />;
    default:
      return <TextFieldsOutlinedIcon />;
  }
};

export default QuestionTypeIcon;
